import React, { useEffect, useCallback, useState} from 'react';
import AudioInputChooser from 'components/AudioInputChooser.js';
import SampleRateChooser from './SampleRateChooser.js';
import {connect} from 'react-redux';

const Audio = ({sequencerEngine}) => { 
    let [deviceId, setDeviceId] = useState(undefined);
    let [multi, setMulti] = useState(!sequencerEngine.channelMixer.stereoConnected);

    const onChooseAudio = useCallback((stream, deviceId) => {
        sequencerEngine.audioInputManager.newInputSource(stream, deviceId);
        setDeviceId(deviceId);
    }, [setDeviceId]);


    const switchOutputs = useCallback((isMulti) => {
        sequencerEngine.channelMixer.switchOutputs(isMulti);
        setMulti(isMulti);
    }, [setMulti]);
    return (
        <div className="audio">
          <SampleRateChooser
            sequencerEngine={sequencerEngine}
          />
          <AudioInputChooser
            deviceId={sequencerEngine.audioInputManager.deviceId}
            defaultClassName="preferences-audio-chooser" onChooseAudio={onChooseAudio}/>
          <MultiChannelButton
            isMultiChannelOutput={multi}
            numberOfChannels={sequencerEngine.channelMixer.numberOfChannels()}
            onClick={switchOutputs} />
        </div>
    );
}

const MultiChannelButton = (props) => {
    return (
        <div onClick={() => props.onClick(!props.isMultiChannelOutput)} className="audio-outputs-option">
          {props.isMultiChannelOutput ? 'MULTI CHANNEL OUTPUT ' : 'SINGLE OUTPUT '}
          ({props.numberOfChannels} channels)
        </div>
    );
}



const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Audio);
